import React, { useEffect } from 'react';
import { Col, Div, Icon, Input, Row, Text } from '@pinpoint/design-kit';

import CONSTANTS from 'src/store/constants';
import { Card, FileDrop, Button } from 'src/components';

/* eslint-disable react/prop-types */

export const cardProps = {
  iconProps: {
    name: 'ThinkalikeModel',
    color: 'white',
    size: '3.125rem',
    viewBox: '0 0 45 60',
  },
  titleProps: {
    bg: 'teal',
    h: '5.5rem',
    p: { l: '2.5rem', r: '2.625rem' },
    rounded: { tr: 'md', tl: 'md' },
  },
  titleTextProps: {
    textColor: 'white',
    textSize: 'title',
    lineHeight: 'title',
  },
  cardProps: {
    p: '0',
    textSize: 'paragraph',
    style: {
      lineHeight: '1.5rem',
    },
    rounded: 'md',
    textColor: 'shade66',
  },
};

export function TopButtons() {
  return (
    <Row p={{ b: '1.25rem' }}>
      <Col size="12">
        <Div m={{ t: '1rem' }} d="flex" justify="flex-start">
          <Button
            buttonStyle="primary"
            onClick={() => {
              window.open('/static/Pinpoint_Target_Onboarding_Template_Updated_18-I-24.xlsx');
            }}
            data-tip="Download Target template"
            style={{
              flex: '0 0 auto',
            }}
          >
            <Icon name="Download2" viewBox="0 0 14 14" color="white" m={{ r: '0.5rem' }} size="0.875rem" />
            TARGET TEMPLATE
          </Button>
        </Div>
      </Col>
    </Row>
  );
}

function BottomButtons({ onBack }) {
  return (
    <Row>
      <Col size="12">
        <Div m={{ t: '1rem', x: '-0.5rem' }} d="flex" justify="space-between">
          <Button
            buttonStyle="primary"
            m={{ l: '0.5rem' }}
            onClick={() => {
              onBack();
            }}
            data-tip="go back"
            style={{
              flex: '0 0 auto',
            }}
          >
            <Icon color="white" name="LongLeft" size="1rem" m={{ r: '0.5rem' }} />
            BACK
          </Button>
        </Div>
      </Col>
    </Row>
  );
}

function PredictForward({
  datasetTag,
  handleFileDrop,
  handleFileSelect,
  files,
  stageFiles,
  progress,
  uploadFileStatus,
  datasetName,
  isAdmin,
  compState,
  triggerDetWorkflowStatus,
  // functions
  setDatasetName,
  getTagStyles,
  uploadFiles,
  setCompState,
  onDone,
  goBack,
}) {
  useEffect(() => {
    if (triggerDetWorkflowStatus === CONSTANTS.API.SUCCEEDED) onDone();
  }, [triggerDetWorkflowStatus, onDone]);

  return (
    <>
      <Row>
        <Col size="12">
          <TopButtons />
          <Card
            title="Select file to upload"
            iconProps={cardProps.iconProps}
            titleProps={cardProps.titleProps}
            titleTextProps={cardProps.titleTextProps}
            cardProps={cardProps.cardProps}
          >
            <Row p={{ x: '2.5rem', t: '1.75rem', b: '1.875rem' }}>
              <Col size="5">
                <FileDrop
                  onDrop={handleFileDrop}
                  onSelect={handleFileSelect}
                  droppedFiles={files}
                  setDroppedFiles={stageFiles}
                  progress={progress}
                  uploadFileStatus={uploadFileStatus}
                />
              </Col>
              <Col size="7">
                Dataset Name
                <Input
                  value={datasetName}
                  onChange={(e) => {
                    setDatasetName(e.target.value);
                  }}
                  h="1.875rem"
                  m={{ b: '.875rem', t: '.25rem' }}
                />
                {datasetName.trim().length > 120 && (
                  <Text textColor="danger800" textSize="caption" m={{ t: '.125rem' }}>
                    Dataset name cannot be longer than 120 characters
                  </Text>
                )}
                Type
                <Div
                  align="center"
                  border="1px solid"
                  borderColor="gray500"
                  d="flex"
                  h="1.875rem"
                  m={{ b: '.875rem', t: '.25rem' }}
                  p={{ x: '.75rem' }}
                  rounded="md"
                >
                  <Icon size=".875rem" m={{ r: '.5em' }} alignSelf="center" {...getTagStyles(datasetTag)} />
                  <Text textSize="body" textColor={getTagStyles(datasetTag).color}>
                    {CONSTANTS.SEGMENT.TAG_NAME[datasetTag]}
                  </Text>
                </Div>
                <Div m={{ t: '2.5rem' }} d="flex" justify="flex-end">
                  <Button
                    buttonStyle="primary"
                    m={{ r: '0rem' }}
                    isLoading={compState !== CONSTANTS.COMPONENT.VALIDATION.VALIDATED}
                    disabled={
                      !isAdmin ||
                      uploadFileStatus === CONSTANTS.API.STARTED ||
                      triggerDetWorkflowStatus === CONSTANTS.API.STARTED ||
                      files.length === 0 ||
                      !datasetName.trim() ||
                      compState !== CONSTANTS.COMPONENT.VALIDATION.VALIDATED ||
                      datasetName.trim().length > 120
                    }
                    loading={uploadFileStatus === CONSTANTS.API.STARTED}
                    onClick={() => {
                      setCompState(CONSTANTS.COMPONENT.OPERATION.STARTED);
                      uploadFiles(files, CONSTANTS.S3_PREFIX.ONPOINT_WORKFLOW);
                      setDatasetName(datasetName.trim());
                    }}
                  >
                    UPLOAD
                    <Icon name="UploadForward" viewBox="0 0 14 16" color="white" m={{ l: '0.5rem' }} size="0.875rem" />
                  </Button>
                </Div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <BottomButtons
        onBack={() => {
          goBack();
        }}
      />
    </>
  );
}

export default PredictForward;
